// doctor-frontend/src/pages/owner/CollegeSubjects.jsx
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Card, CardActionArea, CardContent, Grid, Typography, Divider } from '@mui/material';
import { SUBJECT_GROUPS } from '../../constants/subjects';
import OwnerTopNav from '../../components/owner/OwnerTopNav';
import OwnerBrandFooter from '../../components/owner/OwnerBrandFooter';

const ALLOWED_INTERN_TENANTS = ['aiimsjodhpur-cmfm', 'gomco-patiala'];

function useTenantAllow() {
  const { slug } = useParams();
  const internAllowed = useMemo(() => ALLOWED_INTERN_TENANTS.includes(String(slug || '').toLowerCase()), [slug]);
  return { tenantSlug: slug, internAllowed };
}

function openTenantInNewTab(slug) {
  const url = `/t/${encodeURIComponent(slug)}/cmfm-login`;
  window.open(url, '_blank', 'noopener');
}

function ModuleTriad({ subject, tenantSlug, internAllowed }) {
  const items = [
    { label: 'UG', mode: 'ug', enabled: false },
    { label: 'PG', mode: 'pg', enabled: false },
    { label: 'Intern', mode: 'intern', enabled: internAllowed && subject.allowsIntern !== false },
  ];

  return (
    <Grid container spacing={1}>
      {items.map(it => (
        <Grid key={it.mode} item xs={4}>
          <Card variant="outlined" sx={{ opacity: it.enabled ? 1 : 0.6 }}>
            {it.enabled ? (
              <CardActionArea onClick={() => it.mode === 'intern' && openTenantInNewTab(tenantSlug)}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{it.label}</Typography>
                  <Typography variant="caption" color="text.secondary">{it.mode === 'intern' ? 'Open' : 'Coming soon'}</Typography>
                </CardContent>
              </CardActionArea>
            ) : (
              <CardActionArea component="div" role="button" aria-disabled sx={{ cursor: 'not-allowed' }}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{it.label}</Typography>
                  <Typography variant="caption" color="text.secondary">Coming soon</Typography>
                </CardContent>
              </CardActionArea>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default function CollegeSubjects() {
  const { tenantSlug, internAllowed } = useTenantAllow();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
      <OwnerTopNav active="colleges" />
      <Box p={3}>
        <Typography variant="h6" sx={{ mb: 1 }}>Academic & Training Areas • {tenantSlug}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Undergraduate and postgraduate modules are planned. The internship module is
          {internAllowed ? ' enabled for this institution.' : ' not enabled for this institution.'}
        </Typography>

        {SUBJECT_GROUPS.map(group => (
          <Box key={group.key} sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>{group.title}</Typography>
            <Divider sx={{ mb: 2 }} />

            <Grid container spacing={2}>
              {group.subjects.map(s => (
                <Grid key={s.slug} item xs={12} sm={6} md={4} lg={3}>
                  <Card variant="outlined" sx={{ height: '100%', bgcolor: 'background.paper' }}>
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>{s.name}</Typography>
                      <ModuleTriad subject={s} tenantSlug={tenantSlug} internAllowed={internAllowed} />
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
        <OwnerBrandFooter />
      </Box>
    </Box>
  );
}
